import React, { useCallback, useEffect } from 'react'
import HomeLayout from '../homeLayout'
import { EventTypes, OptionChainViewKey, ViewType } from '../../assets/constants'
import OptionChainTab from '../home/optionChainTab'
import FnoPageWrapper from '../fnoPageWrapper'
import { useNavigate } from 'react-router-dom'
import ROUTES from '../../assets/routes'
import { SecurityClickEventData } from '../../events/eventTypings'
import eventBus from '../../events/eventBus'
import { Box } from '@mui/material'

const OptionChain: React.FC = () => {
    const navigate = useNavigate()

    const securityClickHandler = useCallback((event: CustomEvent<SecurityClickEventData>) => {
        const { detail: data } = event
        navigate(`${ROUTES.base}?symbol=${data.key}`)
    }, [])

    useEffect(() => {
        eventBus.subscribe(EventTypes.SECURITY_CLICKED, securityClickHandler)
        return () => {
            eventBus.unsubscribe(EventTypes.SECURITY_CLICKED, securityClickHandler)
        }
    }, [])

    return (
        <HomeLayout view={ViewType.OPTION_CHAIN}>
            <FnoPageWrapper>
                <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%', height: '100%', gridArea: 'content' }}>
                    <OptionChainTab optionChainViewKey={OptionChainViewKey.LIVE} />
                </Box>
            </FnoPageWrapper>
        </HomeLayout>
    )
}

export default OptionChain